export default [
  {
    path: '/maskIndex',
    name: 'maskIndex',
    component: () => import('@/views/maskSystem/index'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/maskLabelIndex',
    name: 'maskLabelIndex',
    component: () => import('@/views/maskSystem/label/list'),
    meta: {
      title: '分类管理'
    }
  },
  {
    path: '/maskListIndex',
    name: 'maskListIndex',
    component: () => import('@/views/maskSystem/mask/index'),
    meta: {
      title: '脸谱列表'
    }
  },
  {
    path: '/uploadPage',
    name: 'uploadPage',
    component: () => import('@/views/maskSystem/mask/uploadPage'),
    meta: {
      title: '上传脸谱'
    }
  },
  {
    path: '/facebookEdit',
    name: 'facebookEdit',
    component: () => import('@/views/maskSystem/mask/edit'),
    meta: {
      title: '编辑脸谱'
    }
  },
  {
    path: '/maskUserList',
    name: 'maskUserList',
    component: () => import('@/views/maskSystem/appUser/maskUserList'),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/maskUserLoginLog',
    name: 'maskUserLoginLog',
    component: () => import('@/views/maskSystem/appUser/maskUserLoginLog'),
    meta: {
      title: '用户登录日志'
    }
  },
  {
    path: '/maskFeedbackList',
    name: 'maskFeedbackList',
    component: () => import('@/views/maskSystem/feedback/maskFeedbackList'),
    meta: {
      title: '用户反馈'
    }
  },
  {
    path: '/chaFeedback',
    name: 'chaFeedback',
    component: () => import('@/views/maskSystem/feedback/chaFeedback'),
    meta: {
      title: '问题详情'
    }
  },
  {
    path: '/maskDeviceList',
    name: 'maskDeviceList',
    meta: {
      title: '设备中心'
    },
    component: () => import('@/views/maskSystem/deviceManage/deviceList')
  },
  {
    path: '/maskMachineList',
    name: 'maskMachineList',
    component: () => import('@/views/maskSystem/deviceManage/machineList'),
    meta: {
      title: '机型管理'
    }
  },
  {
    path: '/maskCheckModel',
    name: 'maskCheckModel',
    component: () => import('@/views/maskSystem/deviceManage/checkModel'),
    meta: {
      title: '查看机型'
    }
  },
  {
    path: '/maskAddModelPage',
    name: 'maskAddModelPage',
    meta: {
      title: '新增机型'
    },
    component: () => import('@/views/maskSystem/deviceManage/addModelPage')
  },
  {
    path: '/maskEditModelPage',
    name: 'maskEditModelPage',
    meta: {
      title: '编辑机型'
    },
    component: () => import('@/views/maskSystem/deviceManage/editModelPage')
  },
  {
    path: '/maskVirtualSnBatchList',
    name: 'maskVirtualSnBatchList',
    component: () => import("@/views/maskSystem/deviceManage/virtualSnBatchList"),
    meta: {
      title: '授权许可'
    }
  },
  {
    path: '/maskChannelList',
    name: 'maskChannelList',
    component: () => import('@/views/maskSystem/deviceManage/channelList'),
    meta: {
      title: '渠道管理'
    }
  },
  {
    path: '/maskOtaManger',
    name: 'maskOtaManger',
    component: () => import('@/views/maskSystem/apply/otaManger'),
    meta: {
      title: 'OTA管理'
    }
  },{
    path: '/maskAppManager',
    name: 'maskAppManager',
    component: () => import('@/views/maskSystem/apply/appManager'),
    meta: {
      title: 'APP管理'
    }
  }
  ,{
    path: '/maskOtaUpdateAddPage',
    name: 'maskOtaUpdateAddPage',
    meta: {
      title: 'OTA新增'
    },
    component: () => import('@/views/maskSystem/apply/otaUpdateAddPage')
  },{
    path: '/maskOtaUpdateEditPage',
    name: 'maskOtaUpdateEditPage',
    meta: {
      title: 'OTA编辑'
    },
    component: () => import('@/views/maskSystem/apply/otaUpdateEditPage')
  },{
    path: '/maskAppUpdateAddPage',
    name: 'maskAppUpdateAddPage',
    meta: {
      title: 'App新增'
    },
    component: () => import('@/views/maskSystem/apply/appUpdateAddPage')
  },{
    path: '/maskAppUpdateEditPage',
    name: 'maskAppUpdateEditPage',
    meta: {
      title: 'App编辑'
    },
    component: () => import('@/views/maskSystem/apply/appUpdateEditPage')
  },{
    path: '/maskApkUpdateAddPage',
    name: 'maskApkUpdateAddPage',
    meta: {
      title: 'Apk新增'
    },
    component: () => import('@/views/maskSystem/apply/apkUpdateAddPage')
  },{
    path: '/maskApkUpdateEditPage',
    name: 'maskApkUpdateEditPage',
    meta: {
      title: 'Apk编辑'
    },
    component: () => import('@/views/maskSystem/apply/apkUpdateEditPage')
  },{
    path: '/maskApkManager',
    name: 'maskApkManager',
    meta: {
      title: 'APK管理'
    },
    component: () => import('@/views/maskSystem/apply/apkManager')
  }
  ,{
    path: '/maskOtaDownloadLogs',
    name: 'maskOtaDownloadLogs',
    component: () => import('@/views/maskSystem/apply/otaDownloadLogs'),
    meta: {
      title: 'OTA升级记录'
    }
  },{
    path: '/maskDeviceAppExclude',
    name: 'maskDeviceAppExclude',
    component: () => import('@/views/maskSystem/apply/deviceAppExclude'),
    meta: {
      title: 'APP黑名单'
    }
  },{
    path: '/maskDeviceInstruction',
    name: 'maskDeviceInstruction',
    component: () => import('@/views/maskSystem/deviceManage/deviceInstruction'),
    meta: {
      title: '设备指令'
    }
  },{
    path: '/maskImeiErrorLogList',
    name: 'maskImeiErrorLogList',
    component: () => import('@/views/maskSystem/deviceManage/imeiErrorLogList'),
    meta: {
      title: '设备日志'
    }
  },
  {
    path: '/maskChannelAppPage',
    name: 'maskChannelAppPage',
    component: () => import('@/views/maskSystem/deviceManage/ChannelAppPage'),
    meta: {
      title:'渠道APP管理'
    }
  },
  {
    path: '/maskVirtualSnLicenseList',
    name: 'maskVirtualSnLicenseList',
    meta: {
      title: '授权许可'
    },
    component: () => import('@/views/maskSystem/deviceManage/virtualSnLicenseList'),
  },
  {
    path: '/maskUserMonthRegister',
    name: 'maskUserMonthRegister',
    component: () => import("@/views/maskSystem/bi/userMonthRegister"),
    meta: {
      title: '用户统计'
    }
  },
  {
    path: '/maskDeviceMonthRegister',
    name: 'maskDeviceMonthRegister',
    component: () => import("@/views/maskSystem/bi/deviceMonthRegister"),
    meta: {
      title: '设备统计'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/maskRouter.js